export const filterMenuItemStyle = 'px-[10px] py-[12px] w-full [&&]:text-[14px]';
